import React, { useEffect, useState } from "react";
import "./departmentList.css";
import LeftArrow from "../../Assets/Icons/LeftArrow.png";
import RightArrow from "../../Assets/Icons/RightArrow.png";
import ExtraIcon from "../../Assets/Icons/ExtraIcon.png";
import Widgets from "../../widgets";
import NoData from "../../Assets/Icons/NoData.png";
import { useTranslation } from "react-i18next";
import { getAllDepartments } from "../../modules/department/departmentThunk";
import { resetGetAllDepartment } from "../../modules/department/departmentSlice";
import { useDispatch, useSelector } from "react-redux";
import ToastPopup from "../../widgets/Toast/toastPopup";

const DepartmentList = ({ onItemClick, currentPage, setCurrentPage, scrollToTop, setTotalEntries, handleSearch }) => {
  const dispatch = useDispatch();
  const { getAllDepartment, getAllDepartmentError } = useSelector((state) => state.department);
  const itemsPerPage = 10;
  const { t } = useTranslation();
  const [departmentData, setDepartmentData] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const selectedLanguage = useSelector((state) => state.language.language);
  useEffect(() => {
    if (handleSearch != undefined) {
      fetchDepartment(1, itemsPerPage, "departmentName.en", handleSearch);
    }
  }, [handleSearch]);

  useEffect(() => {
    fetchDepartment();
  }, []);

  useEffect(() => {
    if (getAllDepartmentError) {
      ToastPopup.error(getAllDepartmentError);
    }
    if (getAllDepartment && getAllDepartment.status === "success") {
      setDepartmentData(getAllDepartment.data.departments);
      setCurrentPage(getAllDepartment.data.currentPage);
      setTotalPages(getAllDepartment.data.totalPages);
      setTotalEntries(getAllDepartment.data.totalDocuments);
    }
    dispatch(resetGetAllDepartment());
  }, [getAllDepartment, getAllDepartmentError]);

  const fetchDepartment = (pageNumber = currentPage, limit = itemsPerPage, searchFields = "departmentName", search = handleSearch) => {
    const page = pageNumber ?? currentPage ?? 1;
    const sort = "departmentName";
    dispatch(getAllDepartments({ page, limit, sort, searchFields, search }));
  };

  const handleClick = (pageNumber) => {
    fetchDepartment(pageNumber);
    scrollToTop();
  };

  const handlePrevNext = (direction) => {
    scrollToTop();
    if (direction === "prev" && currentPage > 1) {
      fetchDepartment(currentPage - 1);
    } else if (direction === "next" && currentPage < totalPages) {
      fetchDepartment(currentPage + 1);
    }
  };

  const truncateText = (text) => {
    if (text.length > 100) {
      return text.slice(0, 100) + "...";
    }
    return text;
  };

  const renderPagination = () => {
    const pages = [];
    if (totalPages <= 4) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 2) {
        pages.push(1, 2, { type: "ellipsis" }, totalPages);
      } else if (currentPage >= totalPages - 1) {
        pages.push(1, { type: "ellipsis" }, totalPages - 1, totalPages);
      } else {
        pages.push(1, { type: "ellipsis" }, currentPage, { type: "ellipsis" }, totalPages);
      }
    }
    return pages;
  };
  return (
    <div className="department-modal-overlay">
      <div className="department-modal-content">
        <div className="department-list-box">
          <div className="department-head">
            <div className="department-name-heading">{t("department")}</div>
            <div className="department-duration-heading">{t("duration")}</div>
          </div>
          {departmentData && totalPages > 0 ? (
            <div className="departments">
              {departmentData.map((department, index) => (
                <div key={index} className="department" onClick={() => onItemClick(department)}>
                  <div className="department-name body">
                    <p className="department-name-span">
                      <span>{selectedLanguage === "vietnam" ? department.departmentName.vi : department.departmentName.en}</span>{" "}
                      {!department.isActive && <span className="inactive">{t("inActive")}</span>}
                    </p>
                  </div>
                  <div className="times department-duration">
                    {[...department.duration]
                      .sort((a, b) => a.timeInMinutes - b.timeInMinutes)
                      .map((time, idx) => (
                        <Widgets.TimeBox key={idx} time={time.timeInMinutes} />
                      ))}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-record-container">
              <div className="no-record-icon">
                <img src={NoData} alt="No Data Found" />
              </div>
              <div className="no-record-text">{t("noRecordFound")}</div>
            </div>
          )}
        </div>
      </div>
      <div className="department-pagination-list">
        {totalPages > 0 && (
          <>
            <button onClick={() => handlePrevNext("prev")} disabled={currentPage === 1} className="department-pagination-prev-list">
              <img src={LeftArrow} alt="<" />
            </button>
            {renderPagination().map((page, index) => (
              <button
                key={index}
                onClick={() => typeof page === "number" && handleClick(page)}
                disabled={page === currentPage || page.type === "ellipsis"}
                className={`department-pagination-btn-list ${page === currentPage ? "active-list" : ""} ${page.type === "ellipsis" ? "ellipse" : ""}`}
              >
                {typeof page === "number" ? page : <img src={ExtraIcon} alt="..." className="department-extra-icon" />}
              </button>
            ))}
            <button onClick={() => handlePrevNext("next")} disabled={currentPage === totalPages} className="department-pagination-next-list">
              <img src={RightArrow} alt=">" />
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default DepartmentList;
